/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OrderSearchResultDTO interface.
 */
export function instanceOfOrderSearchResultDTO(value) {
    return true;
}
export function OrderSearchResultDTOFromJSON(json) {
    return OrderSearchResultDTOFromJSONTyped(json, false);
}
export function OrderSearchResultDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'amazonOrderId': json['amazonOrderId'] == null ? undefined : json['amazonOrderId'],
        'buyerOrderId': json['buyerOrderId'] == null ? undefined : json['buyerOrderId'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'purchaseDate': json['purchaseDate'] == null ? undefined : (new Date(json['purchaseDate'])),
        'asin': json['asin'] == null ? undefined : json['asin'],
    };
}
export function OrderSearchResultDTOToJSON(json) {
    return OrderSearchResultDTOToJSONTyped(json, false);
}
export function OrderSearchResultDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'amazonOrderId': value['amazonOrderId'],
        'buyerOrderId': value['buyerOrderId'],
        'marketplace': value['marketplace'],
        'purchaseDate': value['purchaseDate'] == null ? undefined : ((value['purchaseDate']).toISOString()),
        'asin': value['asin'],
    };
}
